/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * One line on a manually-composed Fortnox invoice.
 * @export
 * @interface WebApiIntegrationsDtoFortnoxInvoiceRowDto
 */
export interface WebApiIntegrationsDtoFortnoxInvoiceRowDto {
    /**
     * Row text. Required.
     * @type {string}
     * @memberof WebApiIntegrationsDtoFortnoxInvoiceRowDto
     */
    description?: string | null;
    /**
     * Unit price excluding VAT.
     * @type {number}
     * @memberof WebApiIntegrationsDtoFortnoxInvoiceRowDto
     */
    amount?: number;
    /**
     * VAT percentage. Null is treated as 0 (momsfri) - never Fortnox's 25 % predefined rate.
     * @type {number}
     * @memberof WebApiIntegrationsDtoFortnoxInvoiceRowDto
     */
    vat?: number | null;
    /**
     * Optional Fortnox article to bill the row as.
     * @type {string}
     * @memberof WebApiIntegrationsDtoFortnoxInvoiceRowDto
     */
    articleNumber?: string | null;
    /**
     * Optional Fortnox account override for the row.
     * @type {number}
     * @memberof WebApiIntegrationsDtoFortnoxInvoiceRowDto
     */
    accountNumber?: number | null;
    /**
     * Delivered quantity. Defaults to 1.
     * @type {number}
     * @memberof WebApiIntegrationsDtoFortnoxInvoiceRowDto
     */
    quantity?: number;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoFortnoxInvoiceRowDto interface.
 */
export function instanceOfWebApiIntegrationsDtoFortnoxInvoiceRowDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoFortnoxInvoiceRowDtoFromJSON(json: any): WebApiIntegrationsDtoFortnoxInvoiceRowDto {
    return WebApiIntegrationsDtoFortnoxInvoiceRowDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoFortnoxInvoiceRowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoFortnoxInvoiceRowDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'vat': !exists(json, 'vat') ? undefined : json['vat'],
        'articleNumber': !exists(json, 'articleNumber') ? undefined : json['articleNumber'],
        'accountNumber': !exists(json, 'accountNumber') ? undefined : json['accountNumber'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
    };
}

export function WebApiIntegrationsDtoFortnoxInvoiceRowDtoToJSON(value?: WebApiIntegrationsDtoFortnoxInvoiceRowDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'amount': value.amount,
        'vat': value.vat,
        'articleNumber': value.articleNumber,
        'accountNumber': value.accountNumber,
        'quantity': value.quantity,
    };
}

